import { render, staticRenderFns } from "./BaseQuestionLevel.vue?vue&type=template&id=52f9b6ba&"
import script from "./BaseQuestionLevel.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f9b6ba')) {
      api.createRecord('52f9b6ba', component.options)
    } else {
      api.reload('52f9b6ba', component.options)
    }
    module.hot.accept("./BaseQuestionLevel.vue?vue&type=template&id=52f9b6ba&", function () {
      api.rerender('52f9b6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseQuestionLevel.vue"
export default component.exports